import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

import { BaseHttpService } from '@framework/services';

@Injectable()
export class SchedulerHttpService extends BaseHttpService {
  constructor(httpClient: HttpClient) {
    // API base path for Scheduler under a company
    super(httpClient, '/companies');
  }

  /** Load scheduler for a story */
  public getSchduler(companyId: any, storyId: number, payload?: any) {
    return this.get(`/${companyId}/stories/${storyId}/scheduler/`, payload).pipe(
      map((response: any) => response)
    );
  }

  /** Create a new scheduler */
  public create(companyId: number, storyId: number, payload: any) {
    return this.post(`/${companyId}/stories/${storyId}/scheduler/`, payload).pipe(
      map((response: any) => response)
    );
  }

  /** Update an existing scheduler */
  public update(companyId: number, storyId: number, payload: any) {
    return this.patch(`/${companyId}/stories/${storyId}/scheduler/`, payload).pipe(
      map((response: any) => response)
    );
  }

  /** Delete a scheduler */
  public deleteSchedule(companyId: number, storyId: number) {
    return this.delete(`/${companyId}/stories/${storyId}/scheduler/`).pipe(
      map((response: any) => response)
    );
  }
}
